module.exports = __webpack_public_path__ + "img/in_progress.8a6f9ebc.svg";